import { MatDatepicker } from '@angular/material/datepicker';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Component, ViewEncapsulation, ElementRef, Inject, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { DialogFullScreenComponentContent } from '@toro/common/shared/models/dialogs/dialog-full-screen';
import { AppState } from '@toro/common/shared/interfaces/app-state.interface';
import { Store } from '@ngrx/store';
import { StocksExchangeWalletAction } from '@toro/common/shared/state-management/stocks-exchange-wallet/stocks-exchange-wallet.action';
import { OrderInternalTypeEnum } from '@toro/common/shared/enum/orders/internal-type.enum';
import { OrdersService, Status } from '@toro/common/shared/services/orders/orders.service';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { UtilitiesService } from '@toro/common/shared/services/utilities.service';
import { StocksMarketAction } from '@toro/common/shared/state-management/stocks-market/stocks-market.action';
import { TooltipDirectiveModule } from '@toro/common/shared/directives';
import { Observable, Subscription, zip } from 'rxjs';
import { filter, first, tap } from 'rxjs/operators';
import { DatePipe } from '@angular/common';
import { OrderHistoricService } from 'apps/stock/src/app/shared/services/toro-lumen/order-historic.service';

@AutoUnsubscribe()
@Component({
    selector: 'dialog-historic',
    templateUrl: './dialog-historic.component.html',
    styleUrls: ['./dialog-historic.component.scss'],
    viewProviders: [TooltipDirectiveModule],
    providers: [DatePipe],
    encapsulation: ViewEncapsulation.None,
})
export class DialogHistoricComponent extends DialogFullScreenComponentContent implements OnInit, OnDestroy {

    @ViewChild('datePickerHistory', {static: true})
    public datePickerHistory: MatDatepicker<any>;

    public tooltipBalloon: string = `<div>
            <div class='pop-content font-gray-color--darker'>
                O Resultado é o valor final do investimento menos os custos da Toro, quando houver.
            </div>
        </div>`;

    public historyItems: any[] = [];
    public loading: boolean = false;
    public isMobile: boolean;
    public chipsHistory: any = {};
    public initialDate: Date = new Date();
    public clickedDate: Date;
    public historicOrders$: Observable<any[]>;
    private datesInvestment: any[] = [];
    private stocksExchangeSubscription: Subscription;
    private stocksSubscription: Subscription;
    private tradingDatesSubscription: Subscription;
    private datepickerChangeSubscription: Subscription;
    private originalItems: any[] = [];

    constructor(
        element: ElementRef,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private store: Store<AppState>,
        private orderService: OrdersService,
        private utilsService: UtilitiesService,
        private dialogReference: MatDialogRef<DialogHistoricComponent>,
        private orderHistoricService: OrderHistoricService,
        public datePipe: DatePipe,
    ) {

        super(element);

        this.store.dispatch({ type: StocksExchangeWalletAction.getTradingDates });
        // this.loadInitialState();
    }

    public ngOnInit() {
        this.loading = true;

        this.tradingDatesSubscription = this.store
            .select((stocksExchangeState) => stocksExchangeState.stocksExchange.wallet.tradingDates)
            .pipe(
                filter((dates) => dates && dates.length > 0),
                first(),
            )
            .subscribe((dates) => {
                this.datesInvestment = dates;
                this.datesInvestment.sort((a, b) => (new Date(b) as any) - (new Date(a) as any));
                this.initialDate = this.clickedDate = new Date(this.datesInvestment[0]);
                const filter: string =  this.composeDateFilter(this.datesInvestment[0]);
                const formatedDate = this.datePipe.transform(this.datesInvestment[0], 'dd/MM/yyyy');

                this.historicOrders$ = this.orderHistoricService.getOrders(formatedDate);
                this.store.dispatch({ type: StocksExchangeWalletAction.getMyHistoricStrategies, payload: filter });
            });

        this.listHistoricOrders();
        
        this.isMobile = this.utilsService.isMobile();
        this.datepickerChangeSubscription = this.datePickerHistory._selectedChanged.subscribe((data) => this.dateChange(data));

        super.ngOnInit();
    }

    public ngOnDestroy() {
        // Não remover, necessário para o funcionamento correto do @AutoUnsubscribe
    }

    /**
     * Finaliza o componente
     */
    public dispose = () => super.close(this.dialogReference, null);

    /**
     * Verifica status do investimento
     */
    public isOpened = (stock) => stock.status === 'aberta';
    public isClosed = (stock) => stock.status === 'fechada';
    public isCanceled = (stock) => stock.status === 'cancelada';

    /**
     * Handle do filtro da data
     * @param event resultado do change
     */
    public applyFilter(filterValue: any) {
        let filtered: any;
        const filterId = filterValue.id || filterValue.value.id || 0;
        this.chipsHistory.selected = filterId;

        switch (filterId) {
            case 0:
            case 'todos':
                return this.historyItems = [...this.originalItems];
            case 1:
            case 'abertas':
                filtered = this.originalItems.filter((item) => this.orderService.translateOrderStatus(item).Status === Status.Open);
                return this.historyItems = [...filtered];
            case 2:
            case 'fechadas':
                filtered = this.originalItems.filter((item) => this.orderService.translateOrderStatus(item).Status === Status.Closed);
                return this.historyItems = [...filtered];
            case 3:
            case 'canceladas':
                filtered = this.originalItems.filter((item) => this.orderService.translateOrderStatus(item).Status === Status.Canceled);
                return this.historyItems = [...filtered];
            default:
                return this.historyItems = [...this.originalItems];
        }
    }

    public listHistoricOrders() {
        this.stocksExchangeSubscription = zip(
            this.historicOrders$,
            this.store.select((state) => state.stocksExchange.wallet.strategiesSearch),
        )
        .subscribe(([orders, strategies]) => {
            this.loading = false;

            // Lista de stratégias (inputs)
            const strategiesAux = strategies.map((startegy) => {

                const legStrategyBody = startegy.legs.find((leg) => leg.internalOrderType === OrderInternalTypeEnum.Input) || {};
                legStrategyBody.legs = startegy.legs || [];
                legStrategyBody.closed = this.orderService.translateOrderStatus(startegy).Status === Status.Closed;

                return legStrategyBody;
            });

            // Atualização da hora para stratégias fechadas
            strategiesAux
                .filter((strategy) => strategy.closed)
                .forEach((strategy) => {
                    strategy.transactionTime = strategy.updatedAt;
                });

            // Instrumentos e stress para stratégias fechadas
            const strategiesInstruments = strategiesAux
                .filter((strategy) => strategy.closed)
                .map((strategy) => strategy.symbol);

            this.store.dispatch({type: StocksMarketAction.getInstrumentsInfoByArray, payload: strategiesInstruments});

            this.originalItems = [...orders, ...strategiesAux].filter((item) => !!item)
                .sort((itemA, itemB) => {
                    const dateA = itemA.transactionTime ? itemA.transactionTime : itemA.creationDate;
                    const dateB = itemB.transactionTime ? itemB.transactionTime : itemB.creationDate;
                    return this.utilsService.sortArrayByDate(dateA, dateB);
                });

            this.historyItems = [...this.originalItems];
            this.chipsHistory = {
                selected: 0,
                items: [
                    {
                        id: 0,
                        label: `Todos (${this.historyItems.length})`,
                        value: 'todos',
                    },
                    {
                        id: 1,
                        label: `Abertas (${this.getHistoryStatusCount(Status.Open)})`,
                        value: 'abertas'},
                    {
                        id: 2,
                        label: `Fechadas (${this.getHistoryStatusCount(Status.Closed)})`,
                        value: 'fechadas',
                    },
                    {
                        id: 3,
                        label: `Canceladas (${this.getHistoryStatusCount(Status.Canceled)})`,
                        value: 'canceladas',
                    },
            ]};
        });
    }

    /**
     * Filtrar datas disponíveis do datePicker
     *
     * @param {Date} date
     * @returns boolean
     */
    public filterDatePicker = (date: Date): boolean => {

        const filterDate = date
            .toISOString()
            .split('T')[0];

        return this.datesInvestment
            .map((investmentDate) => new Date(investmentDate).toISOString())
            .map((investmentDate) => investmentDate.split('T')[0])
            .includes(filterDate);

    }

    /**
     * Cria a query pro filtrar as ordens
     * @param date String da data
     * @returns string
     */
    public composeDateFilter(date: string): string {
        const dateToSearch: Date = new Date(date);
        // tslint:disable-next-line:max-line-length
        return `((ExecutionDate ne null) and (day(ExecutionDate) eq ${dateToSearch.getDate()} and month(ExecutionDate) eq ${dateToSearch.getMonth() + 1} and year(ExecutionDate) eq ${dateToSearch.getFullYear()})) or ((CreationDate ne null) and (day(CreationDate) eq ${dateToSearch.getDate()} and month(CreationDate) eq ${dateToSearch.getMonth() + 1} and year(CreationDate) eq ${dateToSearch.getFullYear()}))`;
    }

    /**
     * Handle da mudança de data
     * @param dateString string da data selecionada
     */
    private dateChange(dateString: Date) {
        this.clickedDate = new Date(dateString);
        const filter = this.composeDateFilter(dateString.toString());
        const formatedDate = this.datePipe.transform(dateString, 'dd/MM/yyyy');
        this.historicOrders$ = this.orderHistoricService.getOrders(formatedDate);
        this.store.dispatch({ type: StocksExchangeWalletAction.getMyHistoricStrategies, payload: filter });
        this.loading = true;
        this.listHistoricOrders();
    }

    private getHistoryStatusCount(status: string): number {
        return this.historyItems.filter((item) => this.orderService.translateOrderStatus(item).Status === status).length;
    }
}
